/**
 * Runtime Environment Configuration
 * Reads from window.__RUNTIME_CONFIG__ (injected at container startup)
 * Falls back to import.meta.env (build-time)
 */

interface RuntimeConfig {
  VITE_API_URL?: string
  VITE_AUTH_URL?: string
  VITE_AUTH_SERVICE_URL?: string
  VITE_LOGIN_URL?: string
  VITE_OBSERVABILITY_API_URL?: string
  VITE_ENVIRONMENT?: string
  VITE_APP_VERSION?: string
  VITE_MOCK_AUTH?: string
  VITE_NODE_ENV?: string
  VITE_OTEL_ENABLED?: string
  VITE_OTEL_EXPORTER_OTLP_ENDPOINT?: string
  VITE_OTEL_PROPAGATE_TRACE_HEADERS?: string
}

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig
  }
}

export function getConfig(key: keyof RuntimeConfig, devDefault?: string): string | undefined {
  const runtime = window.__RUNTIME_CONFIG__?.[key]
  if (runtime !== undefined && runtime !== '' && runtime !== 'not-configured' && runtime !== `\${${key}}`) {
    return runtime
  }
  const buildTime = import.meta.env[key]
  if (buildTime !== undefined && buildTime !== '' && buildTime !== 'not-configured') {
    return String(buildTime)
  }
  if (import.meta.env.DEV && devDefault) {
    return devDefault
  }
  return undefined
}

export function getRequiredConfig(key: keyof RuntimeConfig, devDefault?: string): string {
  const value = getConfig(key, devDefault)
  if (value === undefined) {
    throw new Error(`CONFIGURATION ERROR: ${key} is required but not configured.`)
  }
  return value
}
